import React, { useCallback, useMemo, useState } from 'react';
import { Task } from 'shared/types/task';

import { DeleteTasksDialog } from './delete-tasks-dialog';
import { MultiTaskHandlersContext } from './multi-task-handlers-context';
import { DialogProps } from './types';

export type MultiTaskHandlersProviderProps = {
  children: React.ReactNode;
};

enum Dialogs {
  Delete = 'delete',
}

const DialogComponentMap: Record<Dialogs, React.FC<DialogProps>> = {
  [Dialogs.Delete]: DeleteTasksDialog,
};

export const MultiTaskHandlersProvider: React.FC<
  MultiTaskHandlersProviderProps
> = ({ children }) => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [openDialog, setOpenDialog] = useState<Dialogs>();
  const DialogComponent = DialogComponentMap[openDialog!];

  const closeDialog = () => setOpenDialog(undefined);

  const openDeleteTasks = useCallback((tasks: Task[]) => {
    if (!tasks.length) {
      return;
    }
    setTasks(tasks);
    setOpenDialog(Dialogs.Delete);
  }, []);

  const value = useMemo(
    () => ({
      openDeleteTasks,
    }),
    [openDeleteTasks],
  );

  return (
    <MultiTaskHandlersContext.Provider value={value}>
      {children}
      {!!DialogComponent && (
        <DialogComponent onClose={closeDialog} tasks={tasks} />
      )}
    </MultiTaskHandlersContext.Provider>
  );
};
